import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { ServiceLocator } from '@dsivd/prestations-ng';

import { InformationApplicantService } from '../services/information-applicant/information-applicant.service';


export const canActivateLegalRep: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const g = ServiceLocator.injector.get(InformationApplicantService);
    return !g.isApplicantAdult();
};
